import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAugmentedJQuery, IController, IModule, IOnChangesObject, IPromise, IQService, IScope, ITimeoutService, IWindowService} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {InnlastingsindikatorKontroller} from "../../../basis/direktiver/innlastingsindikator";
import {Debugger} from 'debug'
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {DashboardFilterKontroller} from "../dashboardFilter/dashboardFilter";
import {BasisKontroller} from "../../../basis/BasisKontroller";
import {Throttle} from "felles/tjenester/Throttle";
import {CelleInfo, Gruppedata, Posisjon, Segmentring, ÅrshjulGraf} from "./d3ÅrshjulGraf";
import {ÅrshjulCellemeny, ÅrshjulCellemenyKonfigurasjon} from "./årshjulCellemeny";
import {RedigerÅrshjulinnslagDialog} from "./redigerÅrshjulinnslagDialog";
import {ÅrshjulRessurs} from "felles/tjenester/ressurser/ÅrshjulRessurs";
import {mandagIUke} from "felles/tjenester/Datoer";
import {MøteTjeneste} from "web/moduler/møte/MøteTjeneste";
import {dateSomPlainDate} from "felles-ng2/støttefunksjoner/temporalTilDateKonverteringer";
import {Gruppefarge, gruppefarge} from "felles-ng2/modell/Gruppefarge";
import TilgangsrolleMedlem = l.TilgangsrolleMedlem;


const debug: Debugger = require('debug')('ÅrshjulKontroller');
const css = require('./årshjul.scss');


export class ÅrshjulKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmDashboardAarshjul', {
                bindings: {filter: '<'},
                controller: ÅrshjulKontroller.forInjisering(),
                template: require('./årshjul.html')
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.ng.$element,
            regNavn.ng.$window,
            regNavn.ng.$timeout,
            regNavn.md.$mdPanel,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            MøteRessurs.regNavn,
            MøteTjeneste.regNavn,
            ÅrshjulRessurs.regNavn,
            Throttle.regNavn,
            WebNavigasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            ÅrshjulKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $element: IAugmentedJQuery,
                private $window: IWindowService,
                private $timeout: ITimeoutService,
                private $mdPanel: angular.material.IPanelService,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst,
                private møteRes: MøteRessurs,
                private møteTjeneste: MøteTjeneste,
                private årshjulRessurs: ÅrshjulRessurs,
                private throttle: Throttle,
                private navigasjon: WebNavigasjon,
                private gettextCatalog: gettextCatalog) {
        this.init();//kan ikke legges i $onInit da $onChanges kan bli kalt før $onInit
    }

    filter: l.DashboardFiltervalg; //settes via bindings/$onChanges
    periodeTittel: string;
    modell: ÅrshjulModell;

    private årshjulGrafMålelement:Element;
    private årshjulGraf:ÅrshjulGraf;
    private møtedetaljerCache = {};
    private vedResizeHandler:()=>void;
    private visHjelpetekstTimer:IPromise<any>;
    private setFørstkommendeTimer:IPromise<any>;
    private erSkalerGrafTilTilgjengeligHøydeModus = false;

    zoomInn(){
        this.erSkalerGrafTilTilgjengeligHøydeModus = false;
        this.modell.zoomInn();
        this.vedResize();
    }

    zoomUt(){
        this.erSkalerGrafTilTilgjengeligHøydeModus = false;
        this.modell.zoomUt();
        this.vedResize();
    }

    visForrigePeriode() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visForrigePeriode)
    }

    visNestePeriode() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visNestePeriode)
    }

    gaaTilMoete(møteId:string) {
        this.navigasjon.gåTilMøte(møteId);
    }

    erAlleGrupperValgt() {
        return this.filter && this.kontekst.autentiserteGrupper().length == this.filter.gruppeIder.length;
    }

    aapneFilterValg() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visFilter);
    }

    aapneOpprettMoeteMeny() {
        this.$scope.$root.$broadcast(BasisKontroller.eventer.fokuserNyttMøteKnapp);
    }

    $onInit(): void {
        this.registrerVedResizeHandler();
        this.registrerVedPresentasjonsmodusAktivertLytter();
    }

    $onDestroy(): void {
        this.avregistrerVedResizeHandler();
    }

    $onChanges(changes: IOnChangesObject): void {
        if (!changesInneholder(changes, 'filter')) return;
        const endretFilter: l.DashboardFiltervalg = changes['filter'].currentValue;
        const opprinneligFilter: l.DashboardFiltervalg = changes['filter'].previousValue;

        InnlastingsindikatorKontroller.visIndikator(this.$scope.$root);
        this.filterEndret(endretFilter, opprinneligFilter)
            .then(() => InnlastingsindikatorKontroller.skjuleIndikator(this.$scope.$root));
    }

    //hjelpemetoder

    /** initialiserer ting som må være på plass før feks $onChange kalles.
     * kan ikke legges i $onInit da $onChanges kan bli kalt før $onInit */
    private init(): void {
        const konfigurasjon = {
            markertUke: ÅrshjulGraf.ukenummer(new Date()),
            vedKlikkPåCelle: (ringId, celle, pos) => this.vedKlikkPåCelle(ringId, celle, pos),
            vedMouseEnterCelle: (ringId, celle, pos) => this.vedMouseEnterCelle(ringId, celle, pos),
            vedMouseLeaveCelle: (ringId, celle, pos) => this.vedMouseLeaveCelle(ringId, celle, pos)
        };
        this.årshjulGrafMålelement = this.$element.find('#aarshjulkontainer').get()[0];
        this.årshjulGraf = new ÅrshjulGraf(this.årshjulGrafMålelement, konfigurasjon, this.gettextCatalog);
        this.årshjulGraf.initialiser();
        this.modell = new ÅrshjulModell(this.gettextCatalog, this.$q, this.årshjulinfoLaster(), this.møtelaster());

        this.møteRes.finnFørsteTilgjengeligeMøte(new Date()).$promise
            .then(møte => {
                if (_.isNil(møte.id)) return;
                this.modell.foerstkommendeMoete = møte;
                this.setFørstkommendeMøteSomValgtMøte();
            });
    }

    private årshjulinfoLaster() {
        return (gruppeId: string) => this.årshjulRessurs.hentAlle(gruppeId).$promise;
    }

    private møtelaster() {
        return (gruppeId:string, periode:l.PlanPeriode) => this.møteRes.finnMøterTilhørendeGrupperIPerioden(periode.start, periode.slutt, [gruppeId]).$promise;
    }

    private visHjelpetekstForsinket(celle: CelleInfoMedData, pos: Posisjon) {
        const vis = ()=> this.modell.setHjelpetekstForCelle(celle, this.somJustertPosisjon(pos));
        this.visHjelpetekstTimer = this.$timeout( vis, 1000);
    }

    private skjulHjelpetekst() {
        this.$timeout.cancel(this.visHjelpetekstTimer);
        this.modell.resetHjelpetekstForCelle();
    }

    private visMeny(ringId:string, celle:CelleInfoMedData, pos:Posisjon){
        const konfig: ÅrshjulCellemenyKonfigurasjon = {
            celle: celle,
            år: this.årstallValgtPeriode(),
            forelderelement: this.$element.find('.wdk-aah-kontainer'),
            pos: this.somJustertPosisjon(pos),
            callbacks: {
                vedNyttMøte: celle => this.vedNyttMøte(celle),
                vedNyttÅrshjulinnslag: celle => this.vedNyttÅrshjulinnslag(celle)
                //vedRedigerÅrshjulinnslag: celle => this.vedRedigerÅrshjulinnslag(celle),
                //vedSlettÅrshjulinnslag: celle => this.vedSlettÅrshjulinnslag(celle)
            }
        }
        ÅrshjulCellemeny.visMeny(konfig, this.$mdPanel);
    }

    private somJustertPosisjon(pos: Posisjon): HtmlPosisjon {
        let menyPos: HtmlPosisjon = {top: null, bottom: null, left: null, right: null};
        if (_.includes(['SV', 'S', 'SØ'], pos.himmelretning)) menyPos.bottom = `${this.årshjulGraf.ytreDiameterAbsolutt() - pos.y}px`;
        else menyPos.top = `${pos.y}px`;
        if (_.includes(['SØ', 'Ø', 'NØ'], pos.himmelretning)) menyPos.right = `${this.årshjulGraf.ytreDiameterAbsolutt() - pos.x}px`;
        else menyPos.left = `${pos.x}px`;

        menyPos.transformOrigin = `${menyPos.top ? 'top' : 'bottom'} ${menyPos.left ? 'left' : 'right'}`;
        return menyPos;
    }

    private registrerVedPresentasjonsmodusAktivertLytter(){
        //pakker kallet til vedPresentasjonsmodusAktiver inn i en timout slik at gui har fått tid til å rendre endringer som følge av presentasjonsmodus
        this.$scope.$on(BasisKontroller.eventer.presentasjonsmodusAktivert, () => this.$timeout(()=>this.vedPresentasjonsmodusAktiver(), 10));
        this.$scope.$on(BasisKontroller.eventer.presentasjonsmodusDeaktivert, () => this.$timeout(()=>this.vedPresentasjonsmodusDeaktiver(), 10));
    }

    private vedPresentasjonsmodusAktiver(){
        this.erSkalerGrafTilTilgjengeligHøydeModus = true;
        this.vedResize(); //vedResize() kaller skalerGrafTilTilgjengeligHøyde() når erPresentasjonsmodus = true
    }

    private vedPresentasjonsmodusDeaktiver(){
        this.erSkalerGrafTilTilgjengeligHøydeModus = false;
        this.modell.zoomTil(1);
        this.vedResize();
    }

    private skalerGrafTilTilgjengeligHøyde(){
        const tilgjengeligHøyde = this.$window.document.body.getBoundingClientRect().height - (this.$element.closest('#basissideInnhold').scrollTop() + this.årshjulGrafMålelement.getBoundingClientRect().top )
        const skaleringsfaktor = tilgjengeligHøyde / this.årshjulGrafMålelement.getBoundingClientRect().height;
        this.modell.zoomTilAbsolutt(skaleringsfaktor, tilgjengeligHøyde);
    }

    private registrerVedResizeHandler(){
        this.vedResizeHandler = this.throttle.throttle(() => this.vedResize(), 500);
        angular.element(this.$window).on('resize', this.vedResizeHandler);
    }

    private avregistrerVedResizeHandler(){
        angular.element(this.$window).off('resize', this.vedResizeHandler);
    }

    private vedResize(){
        if (this.erSkalerGrafTilTilgjengeligHøydeModus) this.skalerGrafTilTilgjengeligHøyde();
        this.skjulHjelpetekst();
        this.modell.resetValgtElement();
        this.modell
            .dataForAlleMøterOgÅrshjulRinger()
            .then((data: Gruppedata[]) => this.tegnGraf(data))
            .then(() => this.setFørstkommendeMøteSomValgtMøte());
    }

    private vedKlikkPåCelle(ringId:string, celle:CelleInfoMedData, pos:Posisjon){
        if (!this.brukerHarTilgangTilMeny(celle)) return;
        switch (celle.ekstra.type){
            case 'møte':
                this.gaaTilMoete(celle.ekstra.entitet.id)
                this.$scope.$apply();
                break;
            case 'møtetom':
                this.visMeny(ringId, celle, pos);
                this.$scope.$apply();
                break;
            case 'årshjulinnslag':
                this.visÅrshjulinnslag(ringId, celle, pos);
                this.$scope.$apply();
                break;
            case 'årshjulinnslagtom':
                this.visMeny(ringId, celle, pos);
                this.$scope.$apply();
                break;
        }
    }

    private vedMouseEnterCelle(ringId:string, celle:CelleInfoMedData, pos:Posisjon){
        switch (celle.ekstra.type){
            case 'møte':
                this.$timeout.cancel(this.setFørstkommendeTimer);
                this.modell
                    .setValgtMoete(<l.MøteModellEnkel>celle.ekstra.entitet, møteId => this.lastMøteaggregater(møteId), gruppeId => this.kontekst.finnAutentiserteGruppe(gruppeId))
                    .posisjonerValgtCelleKontainer(this.årshjulGraf);
                this.$scope.$apply();
                break;
            case 'møtetom':
                break;
            case 'årshjulinnslag':
                this.$timeout.cancel(this.setFørstkommendeTimer);
                this.modell
                    .setValgtÅrshjulinnslag(<l.ÅrshjulInnslagModell>celle.ekstra.entitet)
                    .posisjonerValgtCelleKontainer(this.årshjulGraf);
                this.$scope.$apply();
                break;
            case 'årshjulinnslagtom':
                break;
        }
        if (this.brukerHarTilgangTilMeny(celle)) this.visHjelpetekstForsinket(celle, pos);
    }

    private vedMouseLeaveCelle(ringId:string, celle:CelleInfoMedData, pos:Posisjon) {
        if (this.modell.valgtMoete?.id !== this.modell.foerstkommendeMoete?.id){
            this.modell.resetValgtElement();
            this.setFørstkommendeMøteSomValgtMøte();
        }
        this.skjulHjelpetekst();
        this.$scope.$apply();
    }

    private vedNyttMøte(celle: CelleInfoMedData) {
        this.møteTjeneste.nyttMøteDialog(celle.ekstra.gruppeId, dateSomPlainDate(this.mandagIUke(celle.ukenummer)));
    }

    private vedNyttÅrshjulinnslag(celle: CelleInfoMedData) {
        RedigerÅrshjulinnslagDialog.visNyttÅrshjulinnslagDialog(celle.ekstra.gruppeId, celle.ukenummer, this.$mdDialog)
            .then(respons => {
                this.modell.nyttÅrshjulinnslag(respons.innslag)
                    .dataForAlleMøterOgÅrshjulRinger()
                    .then((data: Gruppedata[]) => this.tegnGraf(data));
            })
            .catch(_.noop); //bruker kansellerte dialog
    }

    /** bruker må ha skrivetilgang til gruppe for å se andre menyhandlinger enn "møte" (gå til møte) */
    private brukerHarTilgangTilMeny(celle:CelleInfoMedData):boolean{
        if (celle.ekstra.type == 'møte') return true;
        return this.kontekst.inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, celle.ekstra.gruppeId)
    }

    /*private vedRedigerÅrshjulinnslag(celle: CelleInfoMedData) {
        RedigerÅrshjulinnslagDialog.visRedigerÅrshjulinnslagDialog(<l.ÅrshjulInnslagModell>celle.ekstra.entitet, this.$mdDialog)
            .then(oppdatertInnslag => {
                this.modell.oppdatertÅrshjulinnslag(oppdatertInnslag)
                    .dataForAlleMøterOgÅrshjulRinger(this.$q)
                    .then((data: Gruppedata[]) => this.tegnGraf(data));
            });
    }*/

    /*private vedSlettÅrshjulinnslag(celle: CelleInfoMedData) {
        const innslag = <l.ÅrshjulInnslagModell>celle.ekstra.entitet;
        this.dialog.confirm(
            this.gettextCatalog.getString('Slett årshjulinnslag'),
            this.gettextCatalog.getString('Vil du slette årshjulinnslaget med tittel "{{tittel}}"', {tittel: innslag.tittel}),
            this.gettextCatalog.getString('Ja, slett'),
            this.gettextCatalog.getString('Avbryt'))
            .then(() => {
                return this.årshjulRessurs.slettInnslag(innslag.gruppeId, innslag.id)
            })
            .then(() => {
                this.modell.slettetÅrshjulinnslag(innslag)
                    .dataForAlleMøterOgÅrshjulRinger(this.$q)
                    .then((data: Gruppedata[]) => this.tegnGraf(data));
            });
    }*/

    private visÅrshjulinnslag(ringId:string, celle:CelleInfoMedData, pos:Posisjon){
        RedigerÅrshjulinnslagDialog.visÅrshjulinnslagDialog(<l.ÅrshjulInnslagModell>celle.ekstra.entitet, this.$mdDialog)
            .then(respons => {
                debug('visÅrshjulinnslag respons', respons)
                switch (respons.type){
                    case 'oppdatert':
                        this.modell.oppdatertÅrshjulinnslag(respons.innslag)
                        break;
                    case 'nytt':
                        this.modell.nyttÅrshjulinnslag(respons.innslag)
                        break;
                    case 'slettet':
                        this.modell.slettetÅrshjulinnslag(respons.innslag)
                        break;
                }
                this.modell.dataForAlleMøterOgÅrshjulRinger()
                    .then((data: Gruppedata[]) => this.tegnGraf(data));
            })
            .catch(_.noop); //bruker kansellerte dialog
    }

    private setFørstkommendeMøteSomValgtMøte() {
        this.$timeout.cancel(this.setFørstkommendeTimer);
        const setFørstkommende = () => {
            if (_.isNil(this.modell.foerstkommendeMoete)) return;
            this.modell.resetValgtElement()
            this.modell
                .setValgtMoete(this.modell.foerstkommendeMoete, møteId => this.lastMøteaggregater(møteId), gruppeId => this.kontekst.finnAutentiserteGruppe(gruppeId))
                .posisjonerValgtCelleKontainer(this.årshjulGraf);
        };
        this.setFørstkommendeTimer = this.$timeout(setFørstkommende, 1000);
    }

    private lastMøteaggregater(møteId: string):IPromise<l.MøteAggregaterModell> {
        if (_.isNil(this.møtedetaljerCache[møteId]))
            this.møtedetaljerCache[møteId] = this.møteRes.hentMedAggregater(møteId).$promise
                .then(m => m.agregater);

        return this.møtedetaljerCache[møteId]
    }

    private filterEndret(nyttFilter: l.DashboardFiltervalg, opprinneligFilter: l.DashboardFiltervalg): IPromise<any> {
        this.filter = nyttFilter; //strengt tatt ikke nødvendig..
        debug("filterEndret", nyttFilter, opprinneligFilter);

        this.periodeTittel = _.toString(this.årstallValgtPeriode());

        //last alle data på nytt dersom dette er første gang filter settes eller perioden er endret
        if (!opprinneligFilter) return this.populerModellOgTegnGraf();

        if (!_.isEqual(opprinneligFilter.periode, nyttFilter.periode)) return this.populerModellOgTegnGraf();
        if (!_.isEqual(opprinneligFilter.gruppeIder, nyttFilter.gruppeIder)) return this.populerModellOgTegnGraf();

        //kun endringer vi ikke trenger å reagere på
        return this.$q.resolve();
    }

    private populerModellOgTegnGraf(): IPromise<any> {
        this.modell
            .setGrupper(this.inkluderteGrupper())
            .setPeriode(this.filter.periode);

        this.tegnGraf(this.modell.dataForTommeRinger())
        return this.modell.dataForAlleMøterOgÅrshjulRinger()
            .then((data: Gruppedata[]) => {
                this.tegnGraf(data);
                this.modell.posisjonerValgtCelleKontainer(this.årshjulGraf);
            })
    }

    private tegnGraf(data: Gruppedata[]) {
        const tegnedeGrupper = this.årshjulGraf.tegnGruppedata(data);
        this.modell.setUtelatteGrupper(_(data).differenceBy(tegnedeGrupper, g => g.gruppeId).value());
    }

    private inkluderteGrupper():l.EnkelGruppeModell[] {
        return _(this.kontekst.autentiserteGrupper())
            .filter(gruppe => _(this.filter.gruppeIder).includes(gruppe.id))
            .value();
    }

    private årstallValgtPeriode(){
        return this.filter.periode.start.getUTCFullYear();
    }

    private mandagIUke(ukenummer: number): Date {
        return mandagIUke(this.årstallValgtPeriode(), ukenummer);
    }
}

export class ÅrshjulModell {

    foerstkommendeMoete:l.MøteModellEnkel = null;
    valgtGruppe:l.EnkelGruppeModell = null;
    valgtMoete:l.MøteModellEnkel = null;
    valgtMoeteAggregater:l.MøteAggregaterModell = null;
    valgtAarshjulinnslag:l.ÅrshjulInnslagModell;
    valgtInfoKontainerPosisjonStil:HtmlDimensjon;
    valgtInfoKontainerHoyde:number;
    svgKontainerDimensjonStil: {width: string; height: string;};

    visHjelpetekst = false;
    hjelptekstPosisjonStil:HtmlPosisjon;
    musoverCelle:CelleInfoMedData;

    utelatteGrupper:Gruppedata[] = [];

    private grupper:Gruppeinfo[];
    private periode: {start: Date; slutt: Date};

    private årshjulinfoLasterCache:((gruppeId:string)=>IPromise<l.ÅrshjulInnslagModell[]>);
    private møterLasterCache:(gruppeId:string)=>IPromise<l.MøteModellEnkel[]>;

    private møteringHøyde = 50;
    private årshjulinnslagHøyde = 20;
    private årshjulinnslagHøydeRedusert = 14;
    private skaleringsfaktor = 1;

    constructor(private gettextCatalog: gettextCatalog,
                private $q:IQService,
                årshjulinfoLaster: (gruppeId: string) => IPromise<l.ÅrshjulInnslagModell[]>,
                møteLaster: (gruppeId: string, periode: l.PlanPeriode) => IPromise<l.MøteModellEnkel[]>) {
        this.årshjulinfoLasterCache = _.memoize(årshjulinfoLaster);
        this.møterLasterCache = _.memoize(gruppeId => møteLaster(gruppeId, this.periode));
    }

    setGrupper(grupper: l.EnkelGruppeModell[]):ÅrshjulModell {
        this.grupper = _(grupper)
            .map((g: l.EnkelGruppeModell) => (<Gruppeinfo>{
                gruppe: g,
                farger: gruppefarge(g),
                tittel: this.gettextCatalog.getString('{{moetenavn}} i {{grptittel}} i {{orgnavn}}', {moetenavn: g.moetenavn, grptittel: g.tittel, orgnavn: g.organisasjonsnavn})
            }))
            .value();
        return this;
    }

    setPeriode(periode: {start: Date; slutt: Date}):ÅrshjulModell {
        this.periode = periode;
        (<any>this.møterLasterCache).cache.clear();
        return this;
    }

    setUtelatteGrupper(utelatteGrupper:Gruppedata[]) {
        this.utelatteGrupper = utelatteGrupper;
    }

    dataForTommeRinger():Gruppedata[]{
        return _(this.grupper)
            .map((gruppe: Gruppeinfo) => ({
                gruppeId: gruppe.gruppe.id,
                gruppetittel: gruppe.tittel,
                ringer: _.flatten([
                    this.ringMedÅrsplaninnslag(1, gruppe, false, []),
                    this.ringMedMøter(gruppe, [])])
            }))
            .value();
    }

    dataForAlleMøterOgÅrshjulRinger(): IPromise<Gruppedata[]> {
        let promiser: IPromise<Gruppedata>[] = this.grupper
            //ikke last data for grupper vi ikke viser..
            .filter(gruppe => !this.utelatteGrupper.some(utelatt => utelatt.gruppeId == gruppe.gruppe.id))
            .map((gruppe: Gruppeinfo) => this.$q.all([
                this.dataForÅrshjulRinger(gruppe.gruppe.id),
                this.dataForMøteRinger(gruppe.gruppe.id)])
                .then(ringer => ({gruppeId: gruppe.gruppe.id, gruppetittel: gruppe.tittel, ringer: _.flatten(ringer)})));
        return this.$q.all(promiser)
    }

    dataForÅrshjulRinger(gruppeId:string):IPromise<Segmentring[]>{
        return this.årshjulinfoLasterCache(gruppeId)
            .then((innslag:l.ÅrshjulInnslagModell[]) => {
                const kollisjonsfrieInnslag = tilKolisjonsfrieÅrshjulinnslagsamlinger(innslag);
                return kollisjonsfrieInnslag
                    .reverse()
                    .map((innslag, i) => this.ringMedÅrsplaninnslag(i, this.finnGruppe(gruppeId), kollisjonsfrieInnslag.length > 1, innslag));
            });
    }

    dataForMøteRinger(gruppeId:string):IPromise<Segmentring[]>{
        return this.møterLasterCache(gruppeId)
            .then(innslag => [this.ringMedMøter(this.finnGruppe(gruppeId), innslag)]);
    }

    // årshjulinnslag cache relatert

    nyttÅrshjulinnslag(innslag: l.ÅrshjulInnslagModell): ÅrshjulModell {
        this.årshjulinfoLasterCache(innslag.gruppeId)
            .then(samling => samling.push(innslag));
        return this;
    }

    oppdatertÅrshjulinnslag(innslag: l.ÅrshjulInnslagModell): ÅrshjulModell {
        this.årshjulinfoLasterCache(innslag.gruppeId)
            .then(samling => _.assign(_(samling).find(i => i.id === innslag.id), innslag));
        return this;
    }

    slettetÅrshjulinnslag(innslag: l.ÅrshjulInnslagModell): ÅrshjulModell {
        this.årshjulinfoLasterCache(innslag.gruppeId)
            .then(samling => _.remove(samling, i => i.id === innslag.id));
        return this;
    }

    // valgt entitet

    /** plasserer info-boks inn i innerste sirkel*/
    posisjonerValgtCelleKontainer(årshjulGraf: ÅrshjulGraf): ÅrshjulModell {
        const årshjuldiameter = årshjulGraf.ytreDiameterAbsolutt();
        const indreRadius = årshjulGraf.indreDiameterAbsolutt() / 2;

        //plassert info boks inne i innerste sirkel
        const hb = Math.sqrt(2 * (Math.pow(indreRadius, 2)));
        const xy = (årshjuldiameter - hb) / 2;
        this.valgtInfoKontainerPosisjonStil = {left: `${xy}px`, top: `${xy}px`, width: `${hb}px`, height: `${hb}px`};
        this.valgtInfoKontainerHoyde = hb;
        return this;
    }

    setValgtMoete(møte: l.MøteModellEnkel, lastMøteaggregater: (møteId: string) => IPromise<l.MøteAggregaterModell>, lastGruppe: (gruppeId: string) => l.EnkelGruppeModell): ÅrshjulModell {
        this.resetValgtElement()
        this.valgtMoete = møte;
        this.valgtGruppe = lastGruppe(møte.eiendeGruppeId); //kan ikke slå opp i this.grupper da denne kun inneholder valgte grupper, mens angitt møte kan være i en ikke-valgt gruppe (ved visning av førstkommende møte)
        lastMøteaggregater(møte.id).then(aggregater => this.valgtMoeteAggregater = aggregater);
        return this;
    }

    setValgtÅrshjulinnslag(årshjulInnslag: l.ÅrshjulInnslagModell): ÅrshjulModell {
        this.resetValgtElement()
        this.valgtAarshjulinnslag = årshjulInnslag;
        this.valgtGruppe = this.finnGruppe(årshjulInnslag.gruppeId).gruppe;
        return this;
    }

    resetValgtElement(): ÅrshjulModell {
        this.valgtMoete = null;
        this.valgtAarshjulinnslag = null;
        return this;
    }

    //hjelpetekster

    setHjelpetekstForCelle(celle: CelleInfoMedData, pos: HtmlPosisjon){
        this.visHjelpetekst = true;
        this.hjelptekstPosisjonStil = pos;
        this.musoverCelle = celle;
    }

    resetHjelpetekstForCelle() {
        this.visHjelpetekst = false;
    }

    //zooming

    zoomTilAbsolutt(skaleringsfaktor: number, tilgjengeligHøyde:number) {
        this.skaleringsfaktor = skaleringsfaktor;
        this.svgKontainerDimensjonStil = {
            width: `${tilgjengeligHøyde}px`,
            height: `${tilgjengeligHøyde}px`
        }
    }

    zoomTil(skaleringsfaktor: number) {
        this.skaleringsfaktor = skaleringsfaktor;
        this.oppdaterSvgKontainerDimensjonStil();
    }

    zoomInn(){
        if (this.skaleringsfaktor >= 1) return;
        this.skaleringsfaktor += 0.1;
        //kutt ned til kun 1 desimal (feks når zoomTil() har blitt kalt med tall med flere desimaler)
        this.skaleringsfaktor = Math.round(this.skaleringsfaktor * 10) / 10;
        this.oppdaterSvgKontainerDimensjonStil();
    }

    zoomUt(){
        if (this.skaleringsfaktor <= 0.3) return;
        this.skaleringsfaktor -= 0.1;
        //kutt ned til kun 1 desimal (feks når zoomTil() har blitt kalt med tall med flere desimaler)
        this.skaleringsfaktor = Math.round(this.skaleringsfaktor * 10) / 10;
        this.oppdaterSvgKontainerDimensjonStil();
    }

    skaleringsfaktorSomProsent(){
        return Math.floor(this.skaleringsfaktor * 100);
    }

    //hjelpemetoder

    private finnGruppe(gruppeId:string):Gruppeinfo{
        return _(this.grupper).find(g => g.gruppe.id === gruppeId);
    }

    private ringMedMøter(gruppe: Gruppeinfo, møter: l.MøteModellEnkel[]): Segmentring {
        return {
            id: `ring_møter_${gruppe.gruppe.id}`,
            cssklasse: 'e2e-møtering',
            farger: gruppe.farger,
            høyde: this.møteringHøyde,
            bakgrunnstekst: møter.length == 0 ? this.gettextCatalog.getString('Ingen møter - klikk på ringen for å opprette') : null,
            uker: this.ukerMedMøter(gruppe.gruppe.id, møter)
        };
    }

    private ukerMedMøter(gruppeId:string, møter: l.MøteModellEnkel[]): CelleInfoMedData[] {
        const møterPerUke = _(møter)
            .groupBy((møte: l.MøteModellEnkel) => ÅrshjulGraf.ukenummer(møte.dato.start))
            .value();
        return _(ÅrshjulGraf.ukedata())
            .map(d => this.populerCelleMedMøteinfo(d, gruppeId, møterPerUke[d.ukenummer.toString()]))
            .value();
    }

    private populerCelleMedMøteinfo(celle: CelleInfo, gruppeId:string, møte: l.MøteModellEnkel[] | null):CelleInfoMedData {
        celle.tittel = null; //ÅrshjulGraf.ukedata() returnerer uker med tittel=ukenummer, kun uker med møter skal ha tittel satt
        celle.ekstra = {gruppeId: gruppeId, type: 'møtetom'};
        if (!_.isArray(møte)) return <CelleInfoMedData>celle;

        //@todo ta hensyn til at en uke kan inneholde flere møter
        celle.id = møte[0].id;
        celle.tittel = `${møte[0].nummer} ${møte[0].tittel}`;
        celle.ekstra = {
            gruppeId: gruppeId,
            type: 'møte',
            entitet: møte[0]
        };
        return <CelleInfoMedData>celle;
    }

    private ringMedÅrsplaninnslag(indeks:number, gruppe: Gruppeinfo, redusertHøyde:boolean, innslag: l.ÅrshjulInnslagModell[]): Segmentring {
        return {
            id: `ring_årshjul_${gruppe.gruppe.id}_${indeks}`,
            cssklasse: 'e2e-årshjulinnslagring',
            farger: gruppe.farger,
            høyde: redusertHøyde ? this.årshjulinnslagHøydeRedusert : this.årshjulinnslagHøyde,
            bakgrunnstekst: innslag.length == 0 ? this.gettextCatalog.getString('Ingen årshjulinnslag - klikk her for å opprette') : null,
            uker: this.ukerMedÅrshjulInnslag(gruppe.gruppe.id, innslag)
        };
    }

    private ukerMedÅrshjulInnslag(gruppeId:string, innslag: l.ÅrshjulInnslagModell[]): CelleInfoMedData[] {
        const uker = _(ÅrshjulGraf.ukedata())
            .map(d => this.populerCelleMedÅrshjulinnslag(d, gruppeId, null))
            .value();
        let offset = 0;
        _(innslag)
            .sortBy(innslag => innslag.startuke)
            .each((innslag:l.ÅrshjulInnslagModell) => {
                const i = innslag.startuke - 1 - offset;
                uker[i] = this.populerCelleMedÅrshjulinnslag(uker[i], gruppeId, innslag);
                //fjern påfølgende uker som innslaget spenner over
                if (innslag.antallUker > 1) {
                    const fjernede = _.pullAt(uker, _.range(i + 1, i + innslag.antallUker))
                    //håndter innslag som spenner over nyttår - hvor vi må fjerne fra starten av uker-arrayen
                    //baserer oss her på at pullAt returnerer array med 'undefined' innslag for alle posisjoner som lå etter arrayens slutt
                    const antallOverskytende = _(fjernede).filter(i => _.isNil(i)).size()
                    if (antallOverskytende > 0)
                        _.pullAt(uker, _.range(0, antallOverskytende))
                    offset += innslag.antallUker - 1;
                }
            });
        return uker;
    }

    private populerCelleMedÅrshjulinnslag(celle: CelleInfo, gruppeId:string, innslag: l.ÅrshjulInnslagModell | null):CelleInfoMedData {
        celle.tittel = null; //ÅrshjulGraf.ukedata() returnerer uker med tittel=ukenummer, kun uker med årshjulinnslag skal ha tittel satt
        celle.ekstra = {gruppeId: gruppeId, type: 'årshjulinnslagtom'};
        if (_.isNil(innslag)) return <CelleInfoMedData>celle;

        celle.id = innslag.id;
        celle.tittel = innslag.tittel;
        celle.bredde = innslag.antallUker;
        celle.ekstra = {
            gruppeId: gruppeId,
            type: 'årshjulinnslag',
            entitet: innslag
        };
        return <CelleInfoMedData>celle;
    }

    private oppdaterSvgKontainerDimensjonStil(){
        this.svgKontainerDimensjonStil = {
            width: `${ this.skaleringsfaktor*100}%`,
            height: `${this.skaleringsfaktor*100}%`
        }
    }
}

interface Gruppeinfo {
    gruppe: l.EnkelGruppeModell;
    farger: Gruppefarge;
    tittel: string;
}

export interface CelleInfoMedData extends CelleInfo {
    ekstra: {
        gruppeId: string;
        type: 'møte' |'møtetom' | 'årshjulinnslag'|'årshjulinnslagtom';
        entitet?: l.MøteModellEnkel | l.ÅrshjulInnslagModell;
    }
}

export interface HtmlPosisjon {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string
    transformOrigin?: string
}

export interface HtmlDimensjon {
    top: string;
    left: string;
    width: string;
    height: string
}


/** returnerer innslag i angitt liste spred utover et sett av arrayer slik at hver array ikke innholder overlappende innslag */
export function tilKolisjonsfrieÅrshjulinnslagsamlinger(alleInnslag:l.ÅrshjulInnslagModell[]){
    const kollisjonsfrie: l.ÅrshjulInnslagModell[][] = [[]];
    _(alleInnslag).sortBy((i: l.ÅrshjulInnslagModell) => i.startuke).each(innslag => {
        //finn ledig array å putte inn i
        let i = 0;
        while (girKollisjon(innslag, kollisjonsfrie[i++])) {
            if (kollisjonsfrie.length <= i) kollisjonsfrie.push([]);
        }
        kollisjonsfrie[i - 1].push(innslag);
    });
    return kollisjonsfrie;
}

function girKollisjon(kandidat:l.ÅrshjulInnslagModell, måltabell:l.ÅrshjulInnslagModell[]) {
    if (overlapper(kandidat, _.last(måltabell))) return true;
    //dersom kandidaten strekker seg over nyttår må vi sjekke for overlapp mot starten av måltabell
    if (kandidat.startuke + kandidat.antallUker -1 > 52)
        return overlapper({startuke: 1, antallUker: kandidat.startuke + kandidat.antallUker - 1 - 52}, _.first(måltabell))
}

function overlapper(a:{startuke:number, antallUker:number}, b:{startuke:number, antallUker:number}) {
    if (_.isNil(a) || _.isNil(b)) return false;
    //sørger for at a er det større intervallet av a og b (forutsettes av påfølende beregning)
    if (b.antallUker > a.antallUker) {
        let a_ = a;
        a = b;
        b = a_;
    }
    const aSlutt = a.startuke + a.antallUker -1;
    const bSlutt = b.startuke + b.antallUker -1;
    return (b.startuke >= a.startuke && b.startuke <= aSlutt)
        || (bSlutt >= a.startuke && bSlutt <= aSlutt)
}
